import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'atom-select',
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './select.atom.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectAtom implements OnInit {
  @Input() inputControl: FormControl = new FormControl('');
  @Input() options: any[] = [];
  @Input() titleSellect = 'Thể loại';
  @Input() widthClass = 'w-72';

  constructor() {}

  ngOnInit(): void {}
}
